<template>
  <div class="side-menu-overlay" :class="{ open: isOpen }" @click="close"></div>
  <div class="side-menu" :class="{ open: isOpen }">
    <div class="side-menu-header">
      <div class="menu-logo">
        <i class="fa-solid fa-chart-line"></i>
      </div>
      <h3 class="menu-title">Finly</h3>
      <button @click="close" class="menu-close-btn">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
    <div class="side-menu-body">
      <nav class="menu-nav">
        <p class="menu-section-label">Dashboard</p>
        <button 
          v-for="(label, categoryKey) in categoryLabels" 
          :key="categoryKey"
          @click="navigateToCategory(categoryKey)"
          class="menu-item"
          :class="{ active: selectedCategory === categoryKey }"
        >
          <i class="fa-solid menu-icon" :class="{
            'fa-th-large': categoryKey === 'all',
            'fa-wallet': categoryKey === 'budget',
            'fa-chart-line': categoryKey === 'spending',
            'fa-piggy-bank': categoryKey === 'savings',
            'fa-tags': categoryKey === 'categories'
          }"></i>
          <span class="menu-label">{{ label }}</span>
        </button>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedCategory: {
      type: String,
      default: 'all'
    },
    categoryLabels: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    navigateToCategory(category) {
      this.$emit('navigate', category);
    }
  },
  emits: ['close', 'navigate']
}
</script>

<style scoped>
.side-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 9998;
}

.side-menu-overlay.open {
  opacity: 1;
  visibility: visible;
}

@media (min-width: 769px) {
  .side-menu-overlay {
    display: none;
  }
}

.side-menu {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 224px;
  max-width: 85vw;
  background: var(--light-card);
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  transition: transform 0.3s ease-out;
  z-index: 9999;
}

.side-menu.open {
  transform: translateX(0);
}

.side-menu-header {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 1.25rem;
}

.menu-logo {
  width: 28px;
  height: 28px;
  background: var(--btn-primary-color);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.menu-logo i {
  font-size: 1rem;
  color: white;
}

.menu-title {
  flex: 1;
  margin: 0;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--light-text);
  letter-spacing: -0.02em;
}

.menu-close-btn {
  background: none;
  border: none;
  color: var(--light-text-muted);
  font-size: 1rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.menu-close-btn:hover {
  background: var(--nested-container-bg);
  color: var(--light-text);
}

.side-menu-body {
  flex: 1;
  overflow-y: auto;
  padding: 0.75rem;
}

.menu-nav {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.menu-section-label {
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--light-text-muted);
  font-weight: 500;
  padding: 0.5rem;
  margin: 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  background: none;
  border: none;
  color: var(--light-text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
}

.menu-item:hover {
  background: var(--nested-container-bg);
  color: var(--light-text);
}

.menu-item.active {
  background: color-mix(in srgb, var(--btn-primary-color) 15%, transparent);
  color: var(--btn-primary-color);
}

.menu-icon {
  font-size: 1rem;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.menu-item.active .menu-icon {
  color: var(--btn-primary-color);
}

.menu-label {
  flex: 1;
}

@media (max-width: 768px) {
  .side-menu {
    width: 224px;
  }
}
</style>
